
export default {
  name: 'FilterCategories',
  props: {
    categories: {
      type: Array,
      default: () => [],
    }
  },
  emits: [
    'change',
  ],
  computed: {
    activeCategoryFromRoute: function () {
      return this.$route.path.split('/')?.[2] || this.$route.path.split('/')?.[1]
    },
  },
  methods: {
    selectCategory: function(newCategory) {
      this.$emit('change', newCategory);
    },
  },
}
